import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { LIGHT_GRAY_SHADE, LIGHT_GREY, GREY } = colors;
import { AccordionSummary } from '@material-ui/core';
import { Bogle_Regular, Bogle_Medium } from 'constants/constant';

const timeFrameStyle = makeStyles(() => ({
	subHeader: {
		paddingLeft: '16px',
		background: LIGHT_GRAY_SHADE,
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		height: '32px'
	},
	subHeaderText: {
		textTransform: 'capitalize',
		fontSize: '14px',
		fontFamily: `${Bogle_Medium} !important`
	},
	listItemText: {
		fontSize: '14px',
		fontFamily: Bogle_Regular,
		display: 'flex',
		alignItems: 'center'
	},
	subListItem: {
		fontSize: '14px',
		fontFamily: Bogle_Regular,
		display: 'flex',
		alignItems: 'center',
		paddingLeft: 26
	},
	listIcon: {
		display: 'inline-flex',
		alignItems: 'center',
		marginRight: '8px',
		height: '14px'
	},
	accordian: {
		border: `1px solid ${LIGHT_GREY}`,
		borderRight: 0,
		borderLeft: 0
	},
	subHeaderCount: {
		paddingRight: '16px',
		color: GREY,
		fontFamily: Bogle_Medium,
		fontSize: '12px'
	},
	floatRight: {
		position: 'absolute',
		right: '0px',
		padding: '8px'
	},
	listItemTextBussName: {
		display: 'flex',
		flex: 1
	},
	charterOnlyText: {
		fontSize: '12px',
		float: 'right',
		marginRight: '16px'
	}
}));

const StyledAccordionSummary = withStyles({
	root: {
		height: 32,
		minHeight: 32,
		padding: '0 !important',
		'& .MuiSvgIcon-root': {
			height: '14px',
			width: '14px',
			marginRight: '6px'
		},
		'& .MuiAccordionSummary-content': {
			alignItems: 'center',
			margin: '0 6px'
		},
		'&.Mui-expanded': {
			minHeight: 32,
			borderBottom: 0
		}
	}
})(AccordionSummary);

export { timeFrameStyle, StyledAccordionSummary };
